import type { HealthCheckFunction } from '../../types';

const globalObj = window || global;
const defaultHealthcheck = (callback: (obj?: { isSuccess: boolean }) => void) =>
	callback({ isSuccess: true });

export const provideHealthcheck = (healthcheck: HealthCheckFunction = defaultHealthcheck) => {
	globalObj.performHealthcheck = healthcheck;
};
